module.exports = __webpack_public_path__ + "static/WEDDING E&M-377-4c3a23074d89daffa240bac43dfb6cea.jpg";